import React from 'react';
import {
  FDBox, FDStack, FDBodyText, FDHeadlineText, FDStat, FDTooltip,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import CopyWrapper from 'Components/ComponentLibrary/Components/Uncategorized/CopyWrapper/CopyWrapper';
import { formatPhoneNumber } from 'Helpers/Formats';
import HouseholdInfoSectionAvatarPicker from '../HouseholdInfoSectionAvatarPicker/HouseholdInfoSectionAvatarPicker';

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['name'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['age', 'clientId'], {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride(['phoneNumber'], {
    _component: () => FDStat,
    _formatReadOnly: () => formatPhoneNumber,
  }, overrideReadOnly)
  .nameOverride(['email'], {
    _component: () => FDStat,
  }, overrideReadOnly);

const HouseholdInfoSectionClient = ({ resource }) => {
  return (
    <FDStack alignItems={'center'} spacing={1}>
      <HouseholdInfoSectionAvatarPicker resource={resource} size={'xl'} />
      <FDBox>
        <FDStack alignItems={'flex-end'} spacing={1}>
          <FDBox maxWidth={'400px'}>
            <CopyWrapper value={resource.attr('name')}>
              <MetaControl attrName={'name'} metaOverrideSet={metaOverride} resource={resource} />
            </CopyWrapper>
          </FDBox>
          <FDTooltip title={resource.attr('birthDate')}>
            <FDBodyText value={resource.attr('age')} size={'sm'} />
          </FDTooltip>
        </FDStack>
        <CopyWrapper value={resource.attr('clientId')}>
          <FDStack spacing={1}>
            <FDBodyText value={`${resource.meta().field('clientId').attr('prompt')}:`} size={'sm'} />
            <MetaControl attrName={'clientId'} metaOverrideSet={metaOverride} resource={resource} />
          </FDStack>
        </CopyWrapper>
        <FDStack spacing={2}>
          {resource.attr('phoneNumber') && (
            <FDBox maxWidth={'200px'}>
              <CopyWrapper value={resource.attr('phoneNumber')}>
                <MetaControl attrName={'phoneNumber'} metaOverrideSet={metaOverride} resource={resource} />
              </CopyWrapper>
            </FDBox>
          )}
          <FDBox maxWidth={'200px'}>
            <CopyWrapper value={resource.attr('email')}>
              <MetaControl attrName={'email'} metaOverrideSet={metaOverride} resource={resource} />
            </CopyWrapper>
          </FDBox>
        </FDStack>
      </FDBox>
    </FDStack>
  );
};

HouseholdInfoSectionClient.defaultProps = {};

HouseholdInfoSectionClient.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default HouseholdInfoSectionClient;
